import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=19ba8c26&scoped=true&"
import script from "./DefaultButton.vue?vue&type=script&lang=ts&"
export * from "./DefaultButton.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultButton.vue?vue&type=style&index=0&id=19ba8c26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ba8c26",
  null
  
)

export default component.exports